import React from "react";
import { Row, Col, Table, Badge, ProgressBar } from "react-bootstrap";
import Plot from "react-plotly.js";

const SystemsOverviewConnection = ({ data }) => {

  if (!data) return null;

  const devices = JSON.parse(data);

  const devicesArray = Array.isArray(devices)
    ? devices
    : Object.values(devices);

  const laserNames = ["LaserGenius +", "Platino Linear"];

  const datasets = {
    all: devicesArray,
    laser: devicesArray.filter(d => laserNames.includes(d.device)),
    automation: devicesArray.filter(d => !laserNames.includes(d.device))
  };

  const titles = {
    all: "All Devices",
    laser: "Laser Devices",
    automation: "Automation Devices"
  };

  const labelsMap = {
    active: "Devices ACTIVE",
    inactive: "Devices INACTIVE",
    "never active": "Devices NEVER active"
  };

  const colorsMap = {
    active: "#2ca02c",
    inactive: "#ff7f0e",
    "never active": "#d62728"
  };

  const badgeVariant = {
    active: "success",
    inactive: "warning",
    "never active": "danger"
  };

  const getCounts = (dataset) => {

    const counts = {
      active: 0,
      inactive: 0,
      "never active": 0
    };

    dataset.forEach(d => {
      if (counts[d.stato] !== undefined) {
        counts[d.stato] += 1;
      }
    });

    return counts;
  };

  const getPercent = (value, total) => {
    if (total === 0) return 0;
    return ((value / total) * 100).toFixed(1);
  };

  const buildPie = (counts, title) => {

    const labels = Object.keys(counts).map(k => labelsMap[k]);
    const values = Object.values(counts);
    const colors = Object.keys(counts).map(k => colorsMap[k]);

    return {
      data: [{
        type: "pie",
        labels,
        values,
        marker: { colors },
        textinfo: "percent",
        textfont: { size: 12 },
        sort: false,
        hole: 0.15
      }],
      layout: {
        title: {
          text: `<b>${title}</b>`,
          font: { 
            size: 18,
            family: "Comfortaa, sans serif",
           }
        },
        height: 350,
        margin: { t: 50, b: 20, l: 20, r: 20 },
        legend: {
          orientation: "h",
          x: 0.5,
          xanchor: "center",
          y: -0.1,
          font: { size: 11 }
        }
      }
    };
  };

  const counts = {
    all: getCounts(datasets.all),
    laser: getCounts(datasets.laser),
    automation: getCounts(datasets.automation)
  };

  const pies = {
    all: buildPie(counts.all, titles.all),
    laser: buildPie(counts.laser, titles.laser),
    automation: buildPie(counts.automation, titles.automation)
  };

  return (
    <>

      {/* TITLE */}

      <Row className="mt-1 mb-4">
        <Col md={{ span: 8, offset: 2 }}>
          <h4 className="text-center">
            Overview stato di connessione
          </h4>
        </Col>
      </Row>

      {/* CHARTS */}

      <Row className="align-items-center">

        <Col md={6} className="text-center">
          <Plot data={pies.all.data} layout={pies.all.layout} />
        </Col>

        <Col md={6}>

          <Row className="mb-4">
            <Col className="text-center">
              <Plot data={pies.laser.data} layout={pies.laser.layout} />
            </Col>
          </Row>

          <Row>
            <Col className="text-center">
              <Plot data={pies.automation.data} layout={pies.automation.layout} />
            </Col>
          </Row>

        </Col>

      </Row>

      {/* DASHBOARD TABLE */}

      <Row className="mt-4">
        <Col md={{ span: 10, offset: 1 }}>

          <Table striped bordered hover>

            <thead>
              <tr className="text-center">
                <th>Category</th>
                <th>Active</th>
                <th>Inactive</th>
                <th>Never Active</th>
                <th>Distribution</th>
              </tr>
            </thead>

            <tbody>

              {Object.keys(datasets).map(key => {

                const total = datasets[key].length;
                const c = counts[key];

                const pActive = getPercent(c.active, total);
                const pInactive = getPercent(c.inactive, total);
                const pNever = getPercent(c["never active"], total);

                return (
                  <tr key={key} className="align-middle text-center">

                    <td>
                      <b>{titles[key]}</b>
                      <div style={{ fontSize: "12px", color: "#777" }}>
                        {total} devices
                      </div>
                    </td>

                    <td>
                      <Badge bg={badgeVariant.active}>
                        {c.active} ({pActive}%)
                      </Badge>
                    </td>

                    <td>
                      <Badge bg={badgeVariant.inactive} text="dark">
                        {c.inactive} ({pInactive}%)
                      </Badge>
                    </td>

                    <td>
                      <Badge bg={badgeVariant["never active"]}>
                        {c["never active"]} ({pNever}%)
                      </Badge>
                    </td>

                    <td style={{ minWidth: "260px" }}>

                      <ProgressBar>

                        <ProgressBar
                          variant="success"
                          now={pActive}
                          key={1}
                        />

                        <ProgressBar
                          variant="warning"
                          now={pInactive}
                          key={2}
                        />

                        <ProgressBar
                          variant="danger"
                          now={pNever}
                          key={3}
                        />

                      </ProgressBar>

                    </td>

                  </tr>
                );
              })}

            </tbody>

          </Table>

        </Col>
      </Row>

    </>
  );
};

export default SystemsOverviewConnection;